<app-main-layout>
    <div class="content"></div>
</app-main-layout>
<ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '14px', fullScreenBackdrop: true }"></ngx-loading>